import { RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { ArticleEnvironment } from '../environment';
import {
  EditorialArticlePreviewResponse,
  ExpiredUrlResponse,
  ExpiredUrlType,
  SponsoredContentHomepage,
  TopStoriesResponse,
  TrendingIndiaPosts,
  TrendingPostsHomepage,
  WNSTNFollowUpQuestionsResponse,
} from '../entities/article';

export class EditorialToolsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).editorialToolsUrl, session, {
      authorization: true,
    });
  }

  getTrendingIndiaStoriesIds = (): SafePromise<TrendingIndiaPosts[]> => {
    const url = this.URL(`api/trending-india/posts`);
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };

  getEditorialArticlePreview = (nodeId: number | string): SafePromise<EditorialArticlePreviewResponse> => {
    const key = this.session.getEnvironment(ArticleEnvironment).editorialPreviewKey;
    const hostname = this.session.getEnvironment(ArticleEnvironment).url;
    const url = this.URL(`${hostname}services/content/editorial/preview?key=${key}&nid=${nodeId}`);
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };

  getEditorialFollowUpsQuestions = async (nodeId: number | string): SafePromise<WNSTNFollowUpQuestionsResponse> => {
    const hostname = this.session.getEnvironment(ArticleEnvironment).wnstnUrl;
    const url = this.URL(`${hostname}followups/${nodeId}`);
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };

  checkExpiredUrl = (type: ExpiredUrlType, slug: string): SafePromise<ExpiredUrlResponse> => {
    const url = this.URL(`api/v2/expired-urls/${type}/${slug}`);
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };

  getTrendingPostsByTermId = (id: string): SafePromise<TopStoriesResponse> => {
    if (!id?.trim()) {
      return Promise.resolve({ ok: { posts: [], status: 'success', taxonomy: '' } });
    }
    const url = this.URL(`api/v2/trending-posts/taxonomy?term_id=${id}`);
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };

  getTrendingPostsByTermName = (name: string): SafePromise<TopStoriesResponse> => {
    if (!name?.trim()) {
      return Promise.resolve({ ok: { posts: [], status: 'success', taxonomy: 'entities' } });
    }
    const url = this.URL(`api/v2/trending-posts/taxonomy?taxonomy=entities&term=${name}`);
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };

  getTrendingStoriesFromEditorial = (): SafePromise<TrendingPostsHomepage> => {
    const url = this.URL(`api/v2/trending-posts/bz-homepage`);
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };

  getSponsoredContentFromEditorial = (): SafePromise<SponsoredContentHomepage> => {
    const url = this.URL(`api/v2/homepage-blocks/sponsored-content`);
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };
}
